import * as React from "react";

import useAppContextRole from "./useAppContextRole";

import { AppContextRole } from "../types";

export interface AppContextProps {
  children?: React.ReactNode;
  or?: boolean;
}

const makeAppContextContainer =
  (appContextRoles: string[]) =>
  ({ children, or }: AppContextProps) => {
    const [role] = useAppContextRole();
    const isRole = !!role && appContextRoles.includes(role);

    return <>{(isRole || or) && children}</>;
  };

const AppContext = {
  Admin: makeAppContextContainer([AppContextRole.Admin]),
  Instructor: makeAppContextContainer([AppContextRole.Instructor]),
  Learner: makeAppContextContainer([AppContextRole.Learner]),
  InstructorOrLearner: makeAppContextContainer([
    AppContextRole.Instructor,
    AppContextRole.Learner,
  ]),
};

export default AppContext;
